import React, { FC } from 'react';

import formatNumberWithCurrency from '@eika-infrastruktur/format/dist/formatNumberWithCurrency';
import { ListPanel, ListPanelWrapper } from '@eika/link-panel';
import { DarkSkeleton } from '@eika/skeleton';

import ErrorCardWrapper from '../../components/ErrorCardWrapper';
import { useConfig } from '../../defaultConfig';
import { useLoans } from '../../hooks/useLoans';
import { useTranslation } from '../../translations';
import { format } from '../../translations/useTranslation';

import KredittbankenLogo from '../../resources/Kredittbanken-icon-logo.svg';
import './Loans.scss';

const Loans: FC = () => {
    const translated = useTranslation();
    const { data: loans, isLoading, error } = useLoans();
    const {
        links: { loanOverview },
    } = useConfig();

    if (error) {
        return (
            <div className="sgw-content">
                <ErrorCardWrapper exception={error} />
            </div>
        );
    }

    if (isLoading) {
        return (
            <div className="sgw-content">
                <ListPanelWrapper
                    titleContent={<h2 className="typography-subtitle-bold">{translated.loanListTitle}</h2>}
                >
                    <div className="sgw-list-panel">
                        <div className="sgw-list-panel__link">
                            <div className="list-panel--skeleton">
                                <DarkSkeleton height={16} />
                            </div>
                            <div className="list-panel--skeleton">
                                <DarkSkeleton height={16} />
                            </div>
                        </div>
                    </div>
                </ListPanelWrapper>
            </div>
        );
    }

    if (!loans || loans.length === 0) return null;

    return (
        <div className="sgw-content">
            <ListPanelWrapper titleContent={<h2 className="typography-subtitle-bold">{translated.loanListTitle}</h2>}>
                {loans?.map((loan) => (
                    <ListPanel
                        key={loan.accountId}
                        url={`${loanOverview?.url}?id=${loan.accountId}`}
                        prefixTitleElement={<img src={KredittbankenLogo} alt="" />}
                        title={loan.productName}
                        textOne={formatNumberWithCurrency(loan.availableBalance, loan.currency?.toString(), 0)}
                        textTwo={format(translated.nominalInterest, loan.interestRate)}
                    />
                ))}
            </ListPanelWrapper>
        </div>
    );
};

export default Loans;
